import { Document, Employee } from '../../../api/v1';

export const availableDocumentForEmployee =
  (employee: Employee) => (d: Document) =>
    d.visibleToAll ||
    d.employeeIds.includes(employee.id) ||
    d.jobRoleIds.some((j) => employee.jobRoleIds.includes(j));
